import SectionCard from "components/cms/SectionCard";
import { AreaInput, FieldRow, GroupBox, TextInput } from "components/cms/fields";

export const NEWSLETTER_HERO_KEYS = [
  "badge",
  "titleLead",
  "titleAccent",
  "body",
  "perk1",
  "perk2",
  "perk3",
  "latestLabel",
  "readIssue",
  "issueNumber",
  "pastIssues",
];

export const NEWSLETTER_INSIDE_KEYS = [
  "insideEyebrow",
  "insideTitleLead",
  "insideTitleAccent",
  "insideBody",
  "insideItem1",
  "insideItem2",
  "insideItem3",
  "insideItem4",
];

export const NEWSLETTER_ARCHIVE_KEYS = [
  "archiveEyebrow",
  "archiveTitleLead",
  "archiveTitleAccent",
  "archiveEmpty",
];

const INSIDE_ITEMS = ["insideItem1", "insideItem2", "insideItem3", "insideItem4"];

export default function NewsletterPageStack({
  form,
  setField,
  frMap,
  onSaveHero,
  onSaveInside,
  onSaveArchive,
  savingSection,
  canSaveHero,
  canSaveInside,
  canSaveArchive,
}) {
  return (
    <>
      <SectionCard
        title="Hero"
        description="Sign-up copy on /resources/newsletter"
        onSave={onSaveHero}
        saving={savingSection === "hero" || savingSection === "all"}
        canSave={canSaveHero}
      >
        <TextInput label="Badge" path="badge" form={form} setField={setField} frMap={frMap} />
        <FieldRow>
          <TextInput label="Title" path="titleLead" form={form} setField={setField} frMap={frMap} />
          <TextInput label="Title accent" path="titleAccent" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <AreaInput label="Body" path="body" form={form} setField={setField} frMap={frMap} rows={4} />
        <FieldRow>
          <TextInput label="Perk 1" path="perk1" form={form} setField={setField} frMap={frMap} />
          <TextInput label="Perk 2" path="perk2" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <TextInput label="Perk 3" path="perk3" form={form} setField={setField} frMap={frMap} />
        <FieldRow>
          <TextInput label="Latest label" path="latestLabel" form={form} setField={setField} frMap={frMap} />
          <TextInput label="Read issue" path="readIssue" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <FieldRow>
          <TextInput
            label="Issue number"
            path="issueNumber"
            form={form}
            setField={setField}
            frMap={frMap}
            placeholder="Issue {n}"
          />
          <TextInput label="Past issues" path="pastIssues" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
      </SectionCard>

      <SectionCard
        title="What's inside"
        onSave={onSaveInside}
        saving={savingSection === "inside" || savingSection === "all"}
        canSave={canSaveInside}
      >
        <TextInput label="Eyebrow" path="insideEyebrow" form={form} setField={setField} frMap={frMap} />
        <FieldRow>
          <TextInput label="Title" path="insideTitleLead" form={form} setField={setField} frMap={frMap} />
          <TextInput label="Title accent" path="insideTitleAccent" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <AreaInput label="Body" path="insideBody" form={form} setField={setField} frMap={frMap} rows={3} />
        {INSIDE_ITEMS.map((key, index) => (
          <GroupBox key={key} title={`Section ${String(index + 1).padStart(2, "0")}`}>
            <TextInput label="Title" path={`${key}.title`} form={form} setField={setField} frMap={frMap} />
            <AreaInput label="Body" path={`${key}.body`} form={form} setField={setField} frMap={frMap} rows={3} />
          </GroupBox>
        ))}
      </SectionCard>

      <SectionCard
        title="Archive"
        onSave={onSaveArchive}
        saving={savingSection === "archive" || savingSection === "all"}
        canSave={canSaveArchive}
      >
        <TextInput label="Eyebrow" path="archiveEyebrow" form={form} setField={setField} frMap={frMap} />
        <FieldRow>
          <TextInput label="Title" path="archiveTitleLead" form={form} setField={setField} frMap={frMap} />
          <TextInput label="Title accent" path="archiveTitleAccent" form={form} setField={setField} frMap={frMap} />
        </FieldRow>
        <AreaInput label="Empty state" path="archiveEmpty" form={form} setField={setField} frMap={frMap} rows={2} />
      </SectionCard>
    </>
  );
}
